export const ROUTES = {
  destinations: "/vacations/destinations/",
  deals: "/vacations/deals/",
  vacations: "/vacations/",
  whySouthwestGetaways: "/vacations/why-southwest-getaways",
};
